import { render } from "./GrigliaStoricoIntEntita.vue?vue&type=template&id=87e0c8b4"
import script from "./GrigliaStoricoIntEntita.vue?vue&type=script&lang=js"
export * from "./GrigliaStoricoIntEntita.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Ecommerce\\CONAD_MANUTENZIONI\\conad-manutenzioni\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__